export default class Relacionamento {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome;
    }
}